import Highcharts from 'highcharts';

export const createDefaultChartOptions = (
): Highcharts.ChartOptions => ({
  plotBackgroundColor: '#fff',
  plotBorderWidth: 1,
  plotBorderColor: '#fff',
  height: null,
  width: null,
  zooming: {
    type: "x",
    mouseWheel: false,
  },
  resetZoomButton: {
    position: {
      x: -15,
      y: 15,
    },
    relativeTo: 'plotBox',
  },
});
